/** Japanese display order is 姓 (family name) then 名 (given name). */
export function japaneseName(familyName: string, givenName: string): string | null {
  return (
    [familyName, givenName]
      .map((part) => part?.trim() ?? '')
      .filter(Boolean)
      .join(' ') || null
  );
}

/** A comma-separated query param as its parts: `a,b,,c` → `['a', 'b', 'c']`; absent → `[]`. */
export function listParam(value: string | null): string[] {
  return (value ?? '')
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

const DATE_TIME_RE = /^(\d{4})[/-](\d{1,2})[/-](\d{1,2})(?:[T\s](\d{1,2}):(\d{1,2}))?/;

/**
 * `YYYY/MM/DD` (withTime = false) or `YYYY/MM/DD HH:mm` (default), read straight from the
 * wall time in the API string. No zone conversion: the API already stores JST.
 */
export function formatDateTime(value?: string, withTime = true): string {
  if (!value) return '';
  const match = DATE_TIME_RE.exec(value);
  if (!match) return value;
  const [, yyyy, mm, dd, hh, min] = match;
  const datePart = `${yyyy}/${mm.padStart(2, '0')}/${dd.padStart(2, '0')}`;
  return withTime && hh && min ? `${datePart} ${hh.padStart(2, '0')}:${min.padStart(2, '0')}` : datePart;
}

export { controlErrorMessage } from './form-errors';
